// import {
//   FaWifi,
//   FaShuttleVan,
//   FaParking,
//   FaSpa,
//   FaUsers,
//   FaDumbbell,
//   FaSmokingBan,
//   FaConciergeBell,
//   FaUmbrellaBeach,
//   FaCoffee,
// } from "react-icons/fa";
// import "./PropertyAttribute.css";

// const getNestedValue = (obj, path) => {
//   return path.split(".").reduce((acc, part) => acc && acc[part], obj);
// };


// const facilityMap = [
//   { key: "selfCheckIn.mobileInternetProperty", icon: <FaWifi />, label: "Free Wifi" },
//   { key: "transportation.airportShuttle", icon: <FaShuttleVan />, label: "Airport shuttle" },
//   { key: "transportation.parking", icon: <FaParking />, label: "Free parking" },
//   { key: "poolAndSpa.spa", icon: <FaSpa />, label: "Spa" },
//   { key: "topPropertyFacilities.familyRooms", icon: <FaUsers />, label: "Family rooms" },
//   { key: "poolAndSpa.fitnessCenter", icon: <FaDumbbell />, label: "Fitness center" },
//   { key: "topPropertyFacilities.nonSmokingRooms", icon: <FaSmokingBan />, label: "Non-smoking rooms" },
//   { key: "physicalDistancing.mobileAppRoomService", icon: <FaConciergeBell />, label: "Room service" },
//   { key: "topPropertyFacilities.beach", icon: <FaUmbrellaBeach />, label: "Beachfront" },
//   { key: "priceForMeals.breakfast", icon: <FaCoffee />, label: "Breakfast" },
// ];

// const Facilities = ({ property }) => {
//   // property.facilities ke andar true/false honge
//   const availableFacilities = Object.keys(facilityMap).filter(
//     (key) => property?.facilities?.[key] === true
//   );

//   return (
//     <div className="facilities-grid">
//       {facilityMap.map((f, i) =>
//         getNestedValue(property, f.key) === true ? (
//           <div key={i} className="facility-item">
//             {f.icon}
//             <span>{f.label}</span>
//           </div>
//         ) : null
//       )}
//     </div>
//   );
// };

// export default Facilities;




// import {
//   FaWifi,
//   FaShuttleVan,
//   FaParking,
//   FaSpa,
//   FaUsers,
//   FaDumbbell,
//   FaSmokingBan,
//   FaConciergeBell,
//   FaUmbrellaBeach,
//   FaCoffee,
// } from "react-icons/fa";
// import "./PropertyAttribute.css";

// // Helper function to safely get nested values like property.poolAndSpa.spa
// const getNestedValue = (obj, path) => {
//   return path.split(".").reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined), obj);
// };

// // Map of facility keys → label + icon
// const facilityMap = [
//   { key: "selfCheckIn.mobileInternetProperty", icon: <FaWifi />, label: "Free Wifi" },
//   { key: "transportation.airportShuttle", icon: <FaShuttleVan />, label: "Airport Shuttle" },
//   { key: "transportation.parking", icon: <FaParking />, label: "Free Parking" },
//   { key: "poolAndSpa.spa", icon: <FaSpa />, label: "Spa" },
//   { key: "topPropertyFacilities.familyRooms", icon: <FaUsers />, label: "Family Rooms" },
//   { key: "poolAndSpa.fitnessCenter", icon: <FaDumbbell />, label: "Fitness Center" },
//   { key: "topPropertyFacilities.nonSmokingRooms", icon: <FaSmokingBan />, label: "Non-Smoking Rooms" },
//   { key: "physicalDistancing.mobileAppRoomService", icon: <FaConciergeBell />, label: "Room Service" },
//   { key: "topPropertyFacilities.beach", icon: <FaUmbrellaBeach />, label: "Beachfront" },
//   { key: "priceForMeals.breakfast", icon: <FaCoffee />, label: "Breakfast" },
// ];

// const Facilities = ({ property }) => {
//   if (!property) return null;

//   // Filter facilities dynamically (true values only)
//   const availableFacilities = facilityMap.filter(
//     (f) => getNestedValue(property, f.key) === true
//   );

//   return (
//     <div className="facilities-grid">
//       {availableFacilities.length > 0 ? (
//         availableFacilities.map((f, i) => (
//           <div key={i} className="facility-item">
//             {f.icon}
//             <span>{f.label}</span>
//           </div>
//         ))
//       ) : (
//         <p className="no-facilities">No facilities information available.</p>
//       )}
//     </div>
//   );
// };

// export default Facilities;








import {
  FaWifi,
  FaShuttleVan,
  FaParking,
  FaSpa,
  FaUsers,
  FaDumbbell,
  FaSmokingBan,
  FaConciergeBell,
  FaUmbrellaBeach,
  FaCoffee,
  FaCheckCircle,
  FaClock,
  FaSwimmer,
  FaDog,
  FaSnowflake,
  FaTv,
  FaKey,
  FaBroom,
  FaUtensils,
  FaDoorOpen,
  FaBed,
  FaGlassCheers,
  FaHotTub,
  FaLeaf,
  FaTree,
  FaSun,
} from "react-icons/fa";
import "./PropertyAttribute.css";

// ✅ Safely get nested object keys like "poolAndSpa.spa"
const getNestedValue = (obj, path) =>
  path.split(".").reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined), obj);

// ✅ Facility map (true values get displayed)
const facilityMap = [
  // --- General Facilities ---
  { key: "selfCheckIn.mobileInternetProperty", icon: <FaWifi />, label: "Free Wifi" },
  { key: "transportation.airportShuttle", icon: <FaShuttleVan />, label: "Airport Shuttle" },
  { key: "transportation.parking", icon: <FaParking />, label: "Free Parking" },
  { key: "selfCheckIn.available", icon: <FaClock />, label: "Self Check-In" },

  // --- Pool, Spa, Fitness ---
  { key: "poolAndSpa.spa", icon: <FaSpa />, label: "Spa" },
  { key: "poolAndSpa.swimmingPool", icon: <FaSwimmer />, label: "Swimming Pool" },
  { key: "poolAndSpa.fitnessCenter", icon: <FaDumbbell />, label: "Fitness Center" },
  { key: "poolAndSpa.hotTubJacuzzi", icon: <FaHotTub />, label: "Hot Tub / Jacuzzi" },
  { key: "poolAndSpa.sauna", icon: <FaHotTub />, label: "Sauna" },

  // --- Property / Top Facilities ---
  { key: "topPropertyFacilities.familyRooms", icon: <FaUsers />, label: "Family Rooms" },
  { key: "topPropertyFacilities.nonSmokingRooms", icon: <FaSmokingBan />, label: "Non-Smoking Rooms" },
  { key: "topPropertyFacilities.petFriendly", icon: <FaDog />, label: "Pet Friendly" },
  { key: "topPropertyFacilities.beach", icon: <FaUmbrellaBeach />, label: "Beachfront" },
  { key: "topPropertyFacilities.bar", icon: <FaGlassCheers />, label: "Bar" },
  { key: "topPropertyFacilities.garden", icon: <FaTree />, label: "Garden" },
  { key: "topPropertyFacilities.terrace", icon: <FaSun />, label: "Terrace" },

  // --- Room Facilities ---
  { key: "roomFacilities.airConditioning", icon: <FaSnowflake />, label: "Air Conditioning" },
  { key: "roomFacilities.flatScreenTV", icon: <FaTv />, label: "Flat-Screen TV" },
  { key: "roomFacilities.privateBathroom", icon: <FaDoorOpen />, label: "Private Bathroom" },
  { key: "roomFacilities.cleaningService", icon: <FaBroom />, label: "Daily Cleaning" },
  { key: "roomFacilities.kitchen", icon: <FaUtensils />, label: "Kitchen" },
  { key: "roomFacilities.comfortableBed", icon: <FaBed />, label: "Comfortable Beds" },

  // --- Services ---
  { key: "physicalDistancing.mobileAppRoomService", icon: <FaConciergeBell />, label: "Room Service" },
  { key: "security.smartLock", icon: <FaKey />, label: "Smart Key Access" },
  { key: "priceForMeals.breakfast", icon: <FaCoffee />, label: "Breakfast" },
];

// ✅ Extra dynamic attributes (based on props)
const dynamicAttributes = (breakfast, parking) => [
  breakfast?.available && { icon: <FaCoffee />, label: "Breakfast Available" },
  breakfast?.included && { icon: <FaCheckCircle />, label: "Breakfast Included" },
  parking && { icon: <FaParking />, label: "Parking Available" },
].filter(Boolean);

const Facilities = ({ property, breakfast, parking }) => {
  if (!property) return null;

  // ✅ Extract available facilities (only those set to true)
  const availableFacilities = facilityMap.filter(
    (f) => getNestedValue(property, f.key) === true || property?.[f.key] === true
  );

  // ✅ Merge all static and dynamic items
  const allItems = [...availableFacilities, ...dynamicAttributes(breakfast, parking)];

  return (
    <div className="facilities-grid">
      {allItems.length > 0 ? (
        allItems.map((f, i) => (
          <div key={i} className="facility-item">
            {f.icon}
            <span>{f.label}</span>
          </div>
        ))
      ) : (
        <p className="no-facilities">No facilities or attributes available.</p>
      )}
    </div>
  );
};

export default Facilities;
